import { showSuccessMessage } from "../commons/show-success-message";
import { showErrorMessage } from "../commons/show-error-message";
import { approveRequest } from "../../infrastructure/repository/request-repository";
import { adaptRentingApprovalCalculationsPayload } from "../../infrastructure/adapters/adaptRentingDetails";
import { translate as t } from "../../infrastructure/translate/localization";

export default async function approveRentingRequest({
  companyId,
  requestId,
  rentingData,
}: {
  companyId: string;
  requestId: string;
  rentingData: any;
}): Promise<void> {
  const adaptedPayload = adaptRentingApprovalCalculationsPayload(rentingData);
  try {
    await approveRequest({
      companyId,
      category: "renting-benefit",
      requestId,
      payload: adaptedPayload,
    });
    showSuccessMessage(
      t("recurrent-payments-section.successfully-approved-renting-request")
    );
  } catch (error) {
    showErrorMessage(t("common-messages.basic-error-message"));
  }
}
